import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

export const state= {
    error: false,
    comments: []
};

const namespaced = true;

export const dialog = {
    namespaced,
    state,
    getters,
    actions,
    mutations,
};